import type React from 'react';
import { useState } from 'react';
import { DEFAULT_CONVERSION_CURRENCY } from '../submission-details/types';
import SubmissionCurrencyTabProps from '../submission-currency-tabs';
import FormActionButtons from 'components/ui/form-action-buttons';
import { SubmissionTabProps } from 'routes/Submissions/SubmissionDetail/navigation-tab/submission-config-tabs';
import LayerResultTable from './components/result-table';
import { useTranslation } from 'react-i18next';

const LayerResults: React.FC<SubmissionTabProps> = ({
  includeBack,
  includeNext,
  navigateBack,
  navigateNext,
  submission,
}) => {
  const [activeCurrencyTab, setActiveCurrencyTab] = useState<string>(
    submission.originalCurrency || DEFAULT_CONVERSION_CURRENCY
  );

  const { t } = useTranslation();

  return (
    <div className="rounded-lg bg-[#E3F2FB]">
      <div className="flex items-center justify-between">
        <SubmissionCurrencyTabProps
          originalCurrency={submission.originalCurrency}
          activeTab={activeCurrencyTab}
          onTabChange={setActiveCurrencyTab}
        />
      </div>
      <LayerResultTable
        currency={activeCurrencyTab}
        submissionId={submission.submissionId}
      />

      <div className="mt-4">
        <FormActionButtons
          confirmText={t('general.next')}
          cancelText={t('general.back')}
          isConfirmDisabled={false}
          includeCancel={includeBack}
          includeConfirm={includeNext}
          confirmOutlined={false}
          onCancel={navigateBack}
          onConfirm={navigateNext}
        />
      </div>
    </div>
  );
};

export default LayerResults;
